import React from 'react'
import CustomerShipmentItemStatusBadge from 'domains/customer-shipment-item/atoms/status-badge'
import { UncontrolledCollapse } from 'reactstrap'

const customerOrderShipmentItemTableColumns = ({ showModalImage }) => {
  // Custom Cell
  // Used to modify the cell in specific columns
  const ImageCell = (row) => (
    <div onClick={ () => showModalImage(row.cell.value) }>
      <img
        style={{ maxHeight: '5rem' }}
        src={ row.cell.value }
        alt={ row.row.original.name }
      />
    </div>

  )

  const NameCell = (row) => {
    const shipmentItemName = row.cell.value
    const shipmentItem     = row.row.original
    const measurements     = shipmentItem.measurements
    const details          = shipmentItem.details

    return (
      <>
        <div>{ shipmentItemName }</div>
        <div style={{ cursor: 'pointer' }} id={ `toggleDetailSize-${shipmentItem.id}` }><b>Size</b>: { shipmentItem.size || '-' } <i className='ml-2 fas fa-chevron-down'/></div>
        <UncontrolledCollapse toggler={ `toggleDetailSize-${shipmentItem.id}` }>
          {
            Object.keys(measurements).map((key) => {
              if (key !== 'weight') {
                return <div key={ `${shipmentItem.id}-meas-${key}` }><b>{ key }</b>: { measurements[key] }</div>
              }
            })
          }
        </UncontrolledCollapse>

        {
          Object.keys(details).map((key) => {
            if (key === 'note' || key === 'condition') {
              return <div key={ `${shipmentItem.id}-details-${key}` }><b>{ key }</b>: { JSON.stringify(details[key]) }</div>
            }
          })
        }
      </>
    )
  }
  const WeightCell = (row) => row.cell.value + ' gr'
  const StatusCell = (row) => <CustomerShipmentItemStatusBadge status={ row.cell.value } />

  const IndexCell = (row) => row.row.index + 1

  return (
    [
      {
        Header         : 'No',
        accessor       : 'id',
        disableFilters : true,
        Cell           : IndexCell
      },
      {
        Header         : 'Image',
        accessor       : 'image',
        disableFilters : true,
        Cell           : ImageCell
      },
      {
        Header   : 'SKU',
        accessor : 'sku'
      },
      {
        Header   : 'Name',
        accessor : 'name',
        Cell     : NameCell
      },
      {
        Header         : 'Qty',
        accessor       : 'quantity',
        disableFilters : true
      },
      {
        Header         : 'Status',
        accessor       : 'status',
        disableFilters : true,
        Cell           : StatusCell
      },
      {
        Header         : 'Weight',
        accessor       : 'weight',
        disableFilters : true,
        Cell           : WeightCell
      }
    ]
  )
}

export default customerOrderShipmentItemTableColumns